import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Building2, ArrowLeft } from "lucide-react";

export default function FirstLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ company_name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const r = await login(form.email, form.password, form.company_name);
    setBusy(false);
    if (!r.ok) return setErr(r.error || "Sign-in failed");
    if (r.user?.must_reset_password) nav("/change-password");
    else nav("/onboarding");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 vb-fade-in" data-testid="first-login-page">
      <form onSubmit={submit} className="w-full max-w-md vb-card p-8" data-testid="first-login-form">
        <Link to="/login" className="vb-link text-sm flex items-center gap-1 mb-3"><ArrowLeft size={14} /> Back to sign in</Link>
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "var(--vb-text-2)" }}>
            <Building2 size={20} color="white" />
          </div>
          <h2 className="vb-heading text-2xl" style={{ color: "var(--vb-text-2)" }}>First-time sign-in</h2>
        </div>
        <p className="opacity-70 mb-5 text-sm">
          Welcome to Vanguard Beacon. To verify it's you, please enter the company name, username and password
          provided by your Vanguard Beacon onboarding contact.
        </p>

        {err && <div className="vb-pill err mb-4 w-full" data-testid="first-error">{err}</div>}

        <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Company name</label>
        <input data-testid="first-company" type="text" required value={form.company_name} onChange={upd("company_name")}
          className="vb-input mb-3" placeholder="e.g. Grand Hyatt Hotel" autoComplete="organization" />

        <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Username / email</label>
        <input data-testid="first-username" type="text" required value={form.email} onChange={upd("email")} className="vb-input mb-3" placeholder="you@company.com" autoComplete="username" />

        <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Temporary password</label>
        <input data-testid="first-password" type="password" required value={form.password} onChange={upd("password")} className="vb-input mb-5" placeholder="Provided by your onboarding contact" autoComplete="current-password" />

        <button type="submit" className="vb-btn w-full" disabled={busy} data-testid="first-submit">
          {busy ? "Signing in…" : "Sign in for the first time"}
        </button>

        <div className="mt-5 text-xs opacity-70 text-center">
          Don't have credentials yet? <Link to="/login" className="vb-link" data-testid="enquire-link-back">Go back to sign in</Link> and click "Enquire about our services".
        </div>
      </form>
    </div>
  );
}
